import { watch, type WatchStopHandle } from 'vue';
import { endSession, useAuthStore } from '@/modules/core/stores/auth.store.ts';
import { Route } from '@/modules/core/enums/route.enum.ts';
import router from '@/router.ts';

let sessionNavigation: Promise<void> | null = null;

function enterSession() {
  const currentRoute = router.currentRoute.value;

  if (currentRoute.name !== Route.LoginPage) {
    return;
  }

  const redirect = currentRoute.query.redirect;
  const redirectLocation = Array.isArray(redirect) ? redirect[0] : redirect;

  sessionNavigation = Promise.resolve(router.replace(redirectLocation ?? { name: Route.AssignmentsPage })).then(
    (failure) => {
      if (failure) {
        throw failure;
      }
    }
  );
  void sessionNavigation.catch(() => {});
}

export function getSessionNavigation(): Promise<void> | null {
  return sessionNavigation;
}

export function retrySessionNavigation(): Promise<void> | null {
  enterSession();
  return sessionNavigation;
}

export function setupAuthSessionSync(): WatchStopHandle {
  const authStore = useAuthStore();
  sessionNavigation = null;

  return watch(
    () => authStore.isAuthorized,
    (isAuthorized, wasAuthorized) => {
      if (wasAuthorized && !isAuthorized) {
        endSession();
        return;
      }

      if (!wasAuthorized && isAuthorized) {
        enterSession();
      }
    },
    { flush: 'sync' }
  );
}
